import { Component, HostListener, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LoginService, UserData, UserInfo } from 'src/app/services/login/login.service';
import { UserService } from 'src/app/services/users/user.service';

@Component({
  selector: 'app-configuration',
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.css']
})
export class ConfigurationComponent implements OnInit {

  navigator : string = 'sidebar.configurazione';
  
  innerWidth: number | undefined;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = window.innerWidth;
  }
 
  userInfo : any | undefined;
  section : string = "rubrica";
  currentUserId : number | undefined;
  currentUser : any | undefined;

  managing : boolean = false;



  constructor(private loginService: LoginService, private translate: TranslateService, private route: ActivatedRoute, private userService: UserService) { }

  async ngOnInit(): Promise<void> {
    this.route.params.subscribe((params: Params) => {this.currentUserId = params.dms_user_id;});
    this.userInfo = await this.loginService.getUserInfo();
    this.currentUser = await this.loginService.getSessionUserInfo();
    this.currentUserId = this.currentUser?.user_id;
    if(this.currentUserId != this.userInfo?.user_id) {
    //  let response = await this.userService.getManagedUserById(this.userInfo!.dms_user_id, this.currentUserId!);
     // this.currentUser = response.data;
      this.managing = true;
    } else {
      this.currentUser = this.userInfo;
    }
  }

  goTo(section : string) {
    this.section = section;
  }

  

}
